import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { translations } from "../../utils/Translation/staticTranslation"

/**
 * The two-tab switch at the top of the Plan Usage page.
 *
 * Deliberately the same `.nav-switch` / `.navbar-tab` markup the Dashboard uses
 * for its Merchant / AI Dashboard switch, so the two pages have one tab idiom
 * rather than two that look almost alike.
 *
 * Tabs are routes, not local state — the Dashboard's are too, and it means a tab
 * survives a refresh and can be linked to directly.
 */

export const PLAN_USAGE_TABS = [
  { key: "plans", path: "/plans-pricing/usage" },
  { key: "tools", path: "/plans-pricing/usage/tools" },
]

const PlanUsageTabs = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.planUsagePage || {}

  // Routes are also served under an `/en` prefix (localizedRouteElements), so
  // compare on the suffix rather than the whole pathname.
  const normalized = pathname.replace(/^\/en(?=\/|$)/, "").replace(/\/$/, "")

  const labels = {
    plans: t.tab_plans || "Plan Usage",
    tools: t.tab_tools || "Generation by Tool",
  }

  return (
    <div className="nav-switch plan-usage-tabs">
      {PLAN_USAGE_TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={`navbar-tab ${normalized === tab.path ? "active" : ""}`}
          onClick={() => navigate(tab.path)}
        >
          {labels[tab.key]}
        </button>
      ))}
    </div>
  )
}

export default PlanUsageTabs
